import api from './api';

/**
 * Payment Service — supports partial and full payments with balance tracking.
 */

const paymentService = {
  getAll: async (params = {}) => {
    const response = await api.get('/payments', { params });
    return response.data;
  },

  getById: async (id) => {
    const response = await api.get(`/payments/${id}`);
    return response.data;
  },

  getBalances: async () => {
    const response = await api.get('/payments/balances');
    return response.data;
  },

  getStudentSummary: async (studentId) => {
    const response = await api.get(`/payments/student/${studentId}/summary`);
    return response.data;
  },

  getStudentHistory: async (studentId) => {
    const response = await api.get(`/payments/student/${studentId}/history`);
    return response.data;
  },

  create: async (data) => {
    const response = await api.post('/payments', data);
    return response.data;
  },

  createWithReceipt: async (studentId, receiptFile, extra = {}) => {
    const formData = new FormData();
    formData.append('student', studentId);
    formData.append('receipt', receiptFile);
    if (extra.amount != null) formData.append('amount', String(extra.amount));
    if (extra.method) formData.append('method', extra.method);
    if (extra.note) formData.append('note', extra.note);
    const response = await api.post('/payments', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  getReceiptUrl: (filename) => {
    if (!filename) return null;
    const base = api.defaults.baseURL || '';
    return `${base}/payments/receipt/${encodeURIComponent(filename)}`;
  },

  update: async (id, data) => {
    const response = await api.put(`/payments/${id}`, data);
    return response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`/payments/${id}`);
    return response.data;
  },
};

export default paymentService;
